import React from "react";

interface MobileCardProps {
  onClick?: () => void;
  className?: string;
  children: React.ReactNode;
  id?: string;
}

export const MobileCard: React.FC<MobileCardProps> = ({
  onClick,
  className = "",
  children,
  id,
}) => (
  <div
    id={id}
    onClick={onClick}
    className={`rounded-lg border border-gray-200 bg-white p-4 shadow-sm ${
      onClick ? "cursor-pointer active:bg-gray-50" : ""
    } ${className}`}
  >
    {children}
  </div>
);

interface MobileFieldProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

export const MobileField: React.FC<MobileFieldProps> = ({
  label,
  children,
  className = "",
}) => (
  <div
    className={`flex items-start justify-between gap-3 py-1 text-xs ${className}`}
  >
    <span className="text-muted-foreground shrink-0 text-xs">{label}</span>
    <span className="min-w-0 break-words text-right font-medium text-gray-900 text-xs">
      {children}
    </span>
  </div>
);

export default MobileCard;
